import Paper from "@mui/material/Paper";
import getKhattabat101CStore from "../../../../stores/khattabat-stores/101c-stores/index";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import KhattabatConversation from "../conversation/KhattabatConversation";

const ClientConversations = withLiteObserverAndTheme<{
  clientID: number;
}>((props) => {
  const { clientID } = props;

  const { oneOOneCId, oneOTwoConversationIds, shouldShowConversation } =
    getKhattabat101CStore(clientID);

  return !shouldShowConversation.get() ? null : (
    <Paper variant="outlined" sx={{ borderRadius: 3, overflow: "hidden" }}>
      <KhattabatConversation conversationID={oneOOneCId.get()} />

      <KhattabatConversation conversationID={`${oneOOneCId.get()}_COMMENTS`} />

      {oneOTwoConversationIds.get().map((oneOTwoConversationId) => {
        return (
          <KhattabatConversation
            key={oneOTwoConversationId}
            conversationID={oneOTwoConversationId}
          />
        );
      })}
    </Paper>
  );
});

export default ClientConversations;
